// src/data/projectsData.js

import basketball from "../assets/projects/basketball.webp";
import tennis from "../assets/projects/tennis.webp";
import running from "../assets/projects/running-track.webp";
import football from "../assets/projects/football.webp";
import pickleball from "../assets/projects/pickleball.webp";
const projectsData = [
  {
    id: 1,

    title: "Basketball Court",

    category: "Basketball",

    location: "NIHOC The International School, Uppal, Hyderabad",

    year: "2026",

    image: basketball,

    featured: true,

    route: "/projects/basketball-delhi",

    area: "18,000 sq.ft",

    surface: "Acrylic",
  },

  {
    id: 2,

    title: "Tennis Court",

    category: "Tennis",

    location: "Academic Heights Public School, Mallampet, Hyderabad",

    year: "2026",

    image: tennis,

    featured: true,

    route: "/projects/tennis-noida",

    area: "9,500 sq.ft",

    surface: "Acrylic",
  },

  {
    id: 3,

    title: "Running Track",

    category: "Athletics",

    location: "IIT Hyderabad",

    year: "2025",

    image: running,

    featured: true,

    route: "/projects/running-track-lucknow",

    area: "32,000 sq.ft",

    surface: "Synthetic",
  },

  {
    id: 4,

    title: "Football Turf",

    category: "Football",

    location: "NorthField International School, Kompally, Hyderabad",

    year: "2026",

    image: football,

    featured: true,

    route: "/projects/football-gurugram",

    area: "42,000 sq.ft",

    surface: "Artificial Turf",
  },

  {
    id: 5,

    title: "Pickleball Court",

    category: "Pickleball",

    location: "Vardhaman College of Engineering, Hyderabad",

    year: "2026",

    image: pickleball,

    featured: true,

    route: "/projects/football-gurugram",

    area: "10,000 sq.ft",

    surface: "Artificial Turf",
  },
];

export default projectsData;
